import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { EntityDefinitionResource } from "../entity-definition-resource";
import { EntityResource } from "../entity-resource";
import OptionListResource from "../option-lists/option-list-resource";
import Resource from "../resource";
import { AggregatedEntityResource, IAggregatedEntityResource } from "./aggregated-entity-resource";

/**
 * Represents a data schema / domain model for an aggregate resource.
 */
@JsonObject()
export class AggregateResource extends Resource {
    @JsonProperty("definitions")
    @JsonElementType(EntityDefinitionResource)
    definitions: Array<EntityDefinitionResource>;

    @JsonProperty("datasources")
    @JsonElementType(OptionListResource)
    optionLists?: Array<OptionListResource>;

    @JsonProperty("items")
    @JsonElementType(AggregatedEntityResource)
    items: Array<IAggregatedEntityResource>;

    @JsonProperty("settings_by_category")
    settingByCategory?: Record<string, Record<string, unknown>>;

    getDefinitionResources(): Array<EntityDefinitionResource> {
        return this.definitions;
    }

    getEntityResources(): Array<EntityResource> {
        const finalItems: Array<EntityResource> = [];

        this.items.forEach(element => {
            finalItems.push(element.entity);
        });

        return finalItems;
    }
}
